import { atom } from 'jotai';

// Default settings state
const defaultSettingsState = {
  isLoaded: false,
  isLoading: false,
  error: null,
  settings: {
    chat_starters: '',
    privacy_disclosure: '',
    feedback_url: '',
    welcome_content: '',
    // Add other settings as needed
  }
};

// Atom to store all application settings
export const settingsAtom = atom(defaultSettingsState);

// Atom to track if settings have been initialized
export const settingsInitializedAtom = atom(false);

// Function to reset settings to default state
export const resetSettings = () => {
  return defaultSettingsState;
};
